/* ASSET */
export const ASSET_LIST = 'ASSET_LIST';
export const ASSET_LIST_SUCCESS = 'ASSET_LIST_SUCCESS';
export const ASSET_LIST_FAILED = 'ASSET_LIST_FAILED';

export const ASSET_ADD = 'ASSET_ADD';
export const ASSET_ADD_SUCCESS = 'ASSET_ADD_SUCCESS';
export const ASSET_ADD_FAILED = 'ASSET_ADD_FAILED';

export const ASSET_UPDATE = 'ASSET_UPDATE';
export const ASSET_UPDATE_SUCCESS = 'ASSET_UPDATE_SUCCESS';
export const ASSET_UPDATE_FAILED = 'ASSET_UPDATE_FAILED';

export const ASSET_DELETE = 'ASSET_DELETE';
export const ASSET_DELETE_SUCCESS = 'ASSET_DELETE_SUCCESS';
export const ASSET_DELETE_FAILED = 'ASSET_DELETE_FAILED';

